import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ChartProps {
  @Inlet(Accepts.Image) public media?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.ChartType) public type?: Types["ChartType"];
  @Inlet(Accepts.ChartVariableList)
  public variables!: Types["ChartVariableList"];
  @Inlet(Accepts.Boolean) public allowSkip?: Types["Boolean"];
  @Inlet(Accepts.Number) public targetValue?: number;
  @Inlet(Accepts.ChartCutoff) public cutoff?: Types["ChartCutoff"];
}

export const ChartDefinition = defineElement("chart", ChartProps, {
  versionRequired: "0.71.0",
});
